var link_viewer_default = {
  "fontElementMap": "AELnQ",
  "link": "xoae0",
  "linkInEditor": "_5O618",
  "linkInViewer": "EEzak",
  "toolbarUrlContainer": "ZLEfE",
  "toolbarUrl": "c4cB7",
  "toolbarUrlAnchor": "_5low8"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
